// extracted by mini-css-extract-plugin
export default {"brandFilter":"brand-filter_brandFilter__R2cWg","label":"brand-filter_label__axq-Q","selectBox":"brand-filter_selectBox__IAl8o","filterButton":"brand-filter_filterButton__I2hds"};